import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import UserUpdateForm from "../../Components/UserUpdateForm/UserUpdateForm";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import EmailIcon from "@mui/icons-material/Email";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ContactlessIcon from "@mui/icons-material/Contactless";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import api from "../../../../utils/apidsf.js";
import { useSelector, useDispatch } from "react-redux";

// css
import "./User.css";

const User = () => {
  const param = useParams();
  const selector = useSelector((state) => state.adminReducer);
  const dispatch = useDispatch();
  const [data, setdata] = useState({
    id: "",
    email: "",
    rawimage: [],
    name: "",
    image: '',
    category: '',
    phone: '',
    role: ''
  });

  useEffect(async () => {
    let id = param?.userId;
    try {
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };

      const res = await api.get(`/admin/?_id=${id}`, config);

      let datavalue = res?.data?.data[0];

      setdata({
        ...data,
        id:id,
        email:datavalue?.email,
        name: datavalue?.name,
        role: datavalue?.role,
        image: datavalue?.image,
        category: datavalue?.category,
        phone: datavalue?.phone,

      })
    } catch (err) {
      console.error(err.response.data.error);
      swal({
        title: "Error",
        text: err.response.data.error,
        icon: "error",
      });
    }
  }, [param]);

  const handleInputChange = (e) => {
    setdata((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleRawImage =(value)=>{
    setdata({
      ...data,
      rawimage:value
    })
  }
  const { name, email, id, image, role ,phone ,category } = data;
  return (
    <div className="admin__user ">
      <div className="admin__containerWidth">
        <div className="admin__titleContainer">
          <h1>Edit User</h1>
          <Link to="/admin/create-user">
            <button className="admin__createUser" style={{
              color:'black'
            }}>Create</button>
          </Link>
        </div>

        <div className="admin__userContainer">
          <div className="admin__userShow">
            <div className="admin__userShowTop">
              <img
                className="admin__userShowImg"
                src={image}
                alt=""
              />
              <div className="userShowTopTitle">
                <span className="admin__username">
                  {name}

                </span>
              </div>
            </div>
            <div className="admin__userShowBottom">
              <span className="userShowTitle">Account Details</span>
              <div className="admin__userShowInfo">
                <PermIdentityIcon className="admin__userShowIcon" />
                <span className="userShowInfoTitle">{name}</span>
              </div>
              <div className="admin__userShowInfo">
                <EmailIcon className="admin__userShowIcon" />
                <span className="userShowInfoTitle">{email}</span>
              </div>
              <div className="admin__userShowInfo">
                <PermIdentityIcon className="admin__userShowIcon" />
                <span className="userShowInfoTitle">{phone}</span>
              </div>
              <div className="admin__userShowInfo">
                <AssignmentIndIcon className="admin__userShowIcon" />
                <span className="userShowInfoTitle">{role}</span>
              </div>
              <div className="admin__userShowInfo">
                <ContactlessIcon className="admin__userShowIcon" />
                <span className="userShowInfoTitle">{category}</span>
              </div>
            </div>
          </div>
          <div className="admin__userUpdate">
            <span className="admin__userUpdateTitle">Edit</span>
            <UserUpdateForm data={data} handleInputChange={handleInputChange} handleRawImage={handleRawImage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
